import { render, staticRenderFns } from "./WheelPanel.vue?vue&type=template&id=1de313b1"
import script from "./WheelPanel.vue?vue&type=script&lang=js"
export * from "./WheelPanel.vue?vue&type=script&lang=js"
import style0 from "./WheelPanel.vue?vue&type=style&index=0&id=1de313b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
